import { z } from 'zod';

import { DepositMethod } from 'data/payments/models';

export const DepositRateType = z.enum([
  'SBER',
  'SBER_2',
  'SBER_LOW',
  'HIGH',
  'FIX_RATE',
  'FIX_RATE_2',
  'FIX_RATE_3',
  'RAPIRA',
  'RAPIRA_PLUS_8',
  'RAPIRA_PLUS_6',
  'RAPIRA_PLUS_6.3',
  'RAPIRA_PLUS_6.5',
  'RAPIRA_PLUS_4',
  'RAPIRA_PLUS_2',
  'RAPIRA_PLUS_1',
  'MNT',
  'UZS',
  'UZS_HTX',
  'AZN',
  'FIX_AZN_RATE',
]);
export type DepositRateType = z.infer<typeof DepositRateType>;

export const DepositRate = z.object({
  rate: z.string(),
  rateType: DepositRateType,
  currency: z.string(),
  methods: z
    .object({
      banks: z.string().array(),
      method: DepositMethod,
      inCurrency: z.string(),
      feePercentage: z.string(),
      effectiveRate: z.string(),
    })
    .array(),
});

export type DepositRate = z.infer<typeof DepositRate>;
